module.exports = __webpack_public_path__ + "img/PD2017490069744648192.e6cb047c.png";